<template>
  <ul class="runNum"></ul>
</template>
<script>
import "../../../common/countTo";
export default {
  name: "DsfSCCountTo",
  props: {
    num: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {};
  },
  watch: {
    num() {
      $(this.$el).html("");
      this.execAni(this.num);
    },
  },
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.execAni(this.num);
  },
  beforeDestroy() {},
  destroyed() {},
  methods: {
    execAni(toNum) {
      if (this.$el) {
        let dom = $(this.$el);
        dom.runNum(toNum, {
          dot: 0,
          speed: 2000,
          width: +dom.css("font-size").replace("px", "") / 2 + 2,
          height: dom.height(),
        });
      }
    },
  },
};
</script>